// libphonenumber is ~37 KB gz: forms on SEO pages load it on demand, not up front.
type PhoneUtils = typeof import('src/utils/phone');

let pending: Promise<PhoneUtils> | undefined;

export const loadPhoneUtils = (): Promise<PhoneUtils> =>
  (pending ??= import('src/utils/phone').catch((error) => {
    // A failed chunk load must not stick: the next call retries.
    pending = undefined;
    throw error;
  }));
